import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { DatasetFacade, UnpublishDialogService } from '@mode/dataset/contract';
import { UnpublishDatasetDialogComponent } from './unpublish-dataset-dialog.component';
import { take } from 'rxjs/operators';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Injectable()
export class UnpublishDatasetDialogService extends UnpublishDialogService {
  constructor(
    private dialogService: DialogService,
    private datasetFacade: DatasetFacade,
    private metaTag: MetaTagsService,
    private analyticsService: AnalyticsService
  ) {
    super();
  }

  public override open(switchViewToken: string) {
    const currentDialog = this.dialogService.open({
      component: UnpublishDatasetDialogComponent,
      matDialogConfig: {
        data: {
          switchViewToken,
        },
      },
    });

    this.listenToDialogEvent(currentDialog);
  }

  private listenToDialogEvent(currentDialog: MatLegacyDialogRef<UnpublishDatasetDialogComponent>) {
    currentDialog.componentInstance.unpublish
      .pipe(take(1))
      .subscribe(({ datasetToken, producerType, switchViewToken, datasetThoughtspotPublicationToken }) => {
        this.datasetFacade.unpublishDataset(
          datasetToken,
          producerType,
          switchViewToken,
          datasetThoughtspotPublicationToken
        );
        const eventData = {
          context: this.analyticsService.context,
          location: AnalyticsEvent.SubContext.UnpublishDatasetModal,
          action: AnalyticsEvent.Name.DatasetUnpublished,
          name: this.metaTag.getTag(MetaTags.CurrentUsername),
        };
        this.analyticsService.track(AnalyticsEvent.Name.UiClicked, eventData);
      });
  }
}
